module.exports = __webpack_public_path__ + "media/theme/icon__paypal-6cdcb9ae.png";